const SURVEY_FORM_NAMESPACE = 'surveyForm';

export { SURVEY_FORM_NAMESPACE };
